import { IRenderGenericTable } from '/shared/Table/context';

import { IFilterCellComponent } from '../IFilterCellProps';

import { TextFilterCell } from './TextFilterCell';
import { NumberFilterCell } from './NumberFilterCell';
import { TagsFilterCell } from './TagsFilterCell';
import { TimeFilterCell } from './TimeFilterCell';
import { OptionsFilterCell } from './OptionsFilterCell';
import { PromotionFilterCell } from './PromotionFilterCell';
import { BooleanFilterCell } from './BooleanFilterCell';
import { KeyValueFilterCell } from './KeyValueFilterCell';
import { ContainsFilterCell } from './ContainsFilterCell';

export const getFilterComponents = (renderGenericTable: IRenderGenericTable) => {
  const PromotionFilterCellComponent: IFilterCellComponent = (props) => (
    <PromotionFilterCell {...props} renderGenericTable={renderGenericTable} />
  );

  PromotionFilterCellComponent.type = PromotionFilterCell.type;

  return [
    TextFilterCell,
    NumberFilterCell,
    TagsFilterCell,
    TimeFilterCell,
    OptionsFilterCell,
    PromotionFilterCellComponent,
    BooleanFilterCell,
    KeyValueFilterCell,
    ContainsFilterCell,
  ];
};
